import React, { useState } from 'react';

export const Flag = (props) => {
  // console.log('NOC  rendered', props)
  const [showImage, setShowImage] = useState(true);
  const hideImg = (event) => {
    // this.setState({ showImg: false });
    setShowImage(false);
  };
  return (
    <>
      {showImage ? (
        <img
          aria-hidden="true"
          src={`/assets/images/flags/${props.noc}.png`}
          alt={props.noc}
          onError={hideImg}
          className={props.className}
        />
      ) : (
        <div className='score-horizontal-flag'></div>
      )}

    </>

  )
};

export const FlagMemo = React.memo(Flag);

export default Flag
